import { Content, Header } from "antd/es/layout/layout";
import { FC, useState } from "react";
import ReservationWrapper from "../../components/overview/ReservationWrapper";
import ServicesWrapper from "../../components/overview/ServicesWrapper";
import PurchasedWrapper from "../../components/overview/PurchasedWrapper";
import SalesWrapper from "../../components/overview/SalesWrapper";
import TeamMembersWrapper from "../../components/overview/TeamMembersWrapper";
import Tour from "../../components/overview/TourOverview";
import HeaderOverview from "../../components/overview/HeaderOverview";
import Statistics from "../../components/overview/Statistics";
import OverviewHero from "../../components/overview/OverviewHero";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../services/react-query/queryKeys";
import { getOverview } from "../../network/overview";
import { Spin } from "antd";
import dayjs from "dayjs";

const Overview = ({}) => {
  const [dateOverview, setDateOverview] = useState({
    start_date: dayjs().startOf("month").format("YYYY-MM-DD"), // Start of last month
    end_date: dayjs().endOf("month").format("YYYY-MM-DD"), // End of this month
  });
  const { data, isLoading } = useQuery(
    [queryKeys.overview, dateOverview],
    () =>
      getOverview({
        start_date: dateOverview.start_date,
        end_date: dateOverview.end_date,
      }),
    {
      select: (data) => data?.data,
    }
  );
  console.log(data, "dataaaaa")
  return (
    <div className="w-full pb-5">
      <HeaderOverview setDateOverview={setDateOverview} />

      {/* <OverviewHero /> */}
      {isLoading ? (
        <Spin className="w-full flex items-center justify-center"></Spin>
      ) : (
        <Content className="bg-[#FBFBFF] grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
          <div className="col-1 grid gap-4 grid-cols-1">
            <ReservationWrapper data={data?.appointments_daily || []} />
            <ServicesWrapper data={data?.services || {}} />
            <PurchasedWrapper data={data?.most_sold_products || {}} />
          </div>
          <div className="">
            <SalesWrapper data={data?.sales || []} />
            <Statistics
              data={data?.statistics || []}
              team_members={data?.team_members || []}
            />
          </div>
        </Content>
      )}
    </div>
  );
};

export default Overview;
